import { createReactiveProperty } from './lib/create-reactive-property';
import { Subject } from 'rxjs';

export function Callback(callbackName: string): PropertyDecorator {
  return (target: Object, propertyKey: string): void => {
    const { subject } = createReactiveProperty({
      target: target.constructor.prototype,
      propertyKey,
      createObservable: () => new Subject(),
    });
    const oldCallback = target.constructor.prototype[callbackName] || (() => {});
    target.constructor.prototype[callbackName] = function (arg): void {
      if (this[propertyKey]) {
        this[subject].next(arg);
      }
      return oldCallback.call(this, arg);
    };
  };
}
